document.addEventListener("DOMContentLoaded", function (){
    let step_name = Shopify?.Checkout?.step;
    if(step_name === "contact_information" || step_name==="shipping_method"){
        $(".address-link").addClass("active");
        $(".card-link").addClass("done");
        $(".card-line").addClass("step-done");
        $(".card-link").removeClass("active");
    }
    else if(step_name==="payment_method"){
        $(".payment-link").addClass("active");
        $(".card-link").addClass("done");
        $(".card-line").addClass("step-done");
        $(".address-link").addClass("done");
        $(".address-line").addClass("step-done");
        $(".card-link").removeClass("active");
    } else if (step_name==="thank_you") {
        $(".payment-link").addClass("active");
        $(".card-link").addClass("done");
        $(".card-line").addClass("step-done");
        $(".address-link").addClass("done");
        $(".address-line").addClass("step-done");
        $(".card-link").removeClass("active");
        $(".payment-link").addClass("done");
        $(".payment-link").removeClass("active");
    }
});